import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingOrganisationSituationSubtitleFR: {
    id: 'charity.vetting.fr.organisation.situation.subtitle',
    defaultMessage: 'Other',
  },
  charityVettingOrganisationSituationTitleFR: {
    id: 'charity.vetting.fr.organisation.situation.title',
    defaultMessage: 'What is your organisation’s status?',
  },
  charityVettingOrganisationSituationLabelFR: {
    id: 'charity.vetting.fr.organisation.situation.label',
    defaultMessage: "Your organisation's status",
  },
  charityVettingOrganisationSituationRequiredFR: {
    id: 'charity.vetting.fr.organisation.situation.required',
    defaultMessage: 'Please provide your organisation’s status',
  },
  charityVettingOrganisationSituationMaxLengthFR: {
    id: 'charity.vetting.fr.organisation.situation.max.length',
    defaultMessage: 'Maximum {max} characters',
  },
  charityVettingOrganisationSituationCharactersRemainingFR: {
    id: 'charity.vetting.fr.organisation.situation.characters.remaining',
    defaultMessage: 'Characters remaining: {count}',
  },
  charityVettingOrganisationSituationCharacterCountFR: {
    id: 'charity.vetting.fr.organisation.situation.character.count',
    defaultMessage: '{current}/{max}',
  },
});

// French placeholder examples — not wrapped in defineMessages to prevent i18n extraction
export const frenchOptions = {
  charityVettingOrganisationSituationPlaceholderFR: {
    id: 'charity.vetting.fr.organisation.situation.placeholder',
    defaultMessage: 'Collectivités locales, Etat, GIP, établissements publics, etc.',
  },
} as const;
